import type { Row } from '@tanstack/react-table';

/**
 * Row id for the node-instance table.
 *
 * NOTE: the `parent` namespace is load-bearing, not decoration. With
 * `parentOnly=false` the list itself contains child instances, and expanding
 * their parent renders them a second time as its sub-rows — so one instance
 * legitimately occupies two rows of the same row model. An id built from
 * `node_instance_id` alone gives those two rows the same id, hence the same
 * React key in the table body, and React then orphans `<tr>` elements instead
 * of removing them: the leftovers survive every later filter change and
 * accumulate on each one. It also merges the two rows' expansion and selection
 * state, so toggling one silently toggles the other.
 *
 * The shape matches TanStack's own default (`parent.id` joined to the child's
 * key), which exists for exactly this reason.
 */
export const nodeInstanceRowId = (row: { node_instance_id: number | string }, _index: number, parent?: Row<unknown>): string =>
  parent ? `${parent.id}.${row.node_instance_id}` : String(row.node_instance_id);
